import { createSlotRecipe } from './runtime.js';

const progressCircleConfig = {"name":"progressCircle","slots":["root","svg","track","border","indicator","content","icon"],"defaultVariants":{"color":"green","isZero":false,"size":"md"},"variantMap":{"color":["green","orange"],"isZero":["false","true"],"size":["md","sm"]}}

export const progressCircle = /* @__PURE__ */ createSlotRecipe(progressCircleConfig)